<div
    class="agpr-sortBlock"
    [class.agpr-sortBlock--curated]="curatedDisplayElement"
    [class.agpr-sortBlock--selected]="selected"
>
    <div
        class="agpr-sortBlock-contents"
        [id]="id"
    >
        @if(layoutBlock) {
            @for (layoutColumn of layoutBlock.blocks; track layoutColumn) {
                <div>
                    @for (layoutBlockChild of layoutColumn; track layoutBlockChild) {
                        <agpr-sort-tool-block
                            [id]="id + '.layoutBlockChild_' + layoutBlockChild.id"
                            [block]="layoutBlockChild"
                        ></agpr-sort-tool-block>
                    }
                </div>
            }
        } @else {
            <span
                *ngIf="!curatedDisplayElement"
                class="agpr-sortBlock-icon"
                [ngClass]="_block.type.icon"
                aria-hidden="true"
            ></span>
            <span class="agpr-sortBlock-title">
                {{ curatedDisplayElement ? curatedDisplayElement.title : '' }}
                <span
                    class="agpr-sortBlock-type"
                    [class.agpr-sortBlock-type--curated]="curatedDisplayElement"
                >{{ _block.type.label | localize }}</span>
            </span>
            <span
                *ngIf="curatedDisplayElement"
                class="agpr-sortBlock-mentionsCount"
            >
                {{ curatedDisplayElement.mentionIds.length }}
            </span>
        }
    </div>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <div
        *ngIf="curatedDisplayElement"
        class="agpr-sortBlock-filter"
        (click)="cancelEvent($event)"
    >
        <span class="agpr-sortBlock-filterDropdown">
            <agpr-filter-dropdown
                [id]="id"
                tooltip="Briefings.mentionList.form.rules.tooltip"
                iconClass="fa-regular fa-duotone fa-network-wired"
            ></agpr-filter-dropdown>
        </span>
        <span class="agpr-sortBlock-filterChips">
            <agpr-filter-chips
                [id]="id"
                overflowMessage="Briefings.mentionList.form.rules.overflowMessage"
                emptyMessage="Briefings.mentionList.form.rules.emptyMessage"
            ></agpr-filter-chips>
        </span>
    </div>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
</div>
